import { storyblokEditable } from '@storyblok/react';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';

export interface IconFeatureProps {
  blok: any;
  content: any;
}

const IconFeature: FC<IconFeatureProps> = ({
  blok,
  content = blok.content,
}) => {
  return (
    <Section {...storyblokEditable(blok)} className="overflow-hidden">
      <Container size={'full'}>
        {content && (
          <Prose
            size="base"
            center={true}
            content={content}
            animate={false}
          ></Prose>
        )}
      </Container>
    </Section>
  );
};

export default IconFeature;
